import { useMemo } from 'react';

import { UFOExperience, useUFOComponentExperience } from '@atlassian/ufo';

import { NavigationExperienceId } from './constant';

export interface UseExperienceTrackerProps {
	id: keyof typeof NavigationExperienceId;
}

function useUFOExperience(
	id: string,
	config: UFOExperience['config'],
	instanceId?: string | null,
): UFOExperience {
	return useMemo(() => new UFOExperience(id, config, instanceId), [id, config, instanceId]);
}

export function useExperienceTracker(key: keyof typeof NavigationExperienceId) {
	const experienceObj = NavigationExperienceId[key];
	const experience = useUFOExperience(
		experienceObj.experienceId,
		experienceObj.config,
		experienceObj.instanceId,
	);
	useUFOComponentExperience(experience); // this hook starts the experience and aborts it when the component is unmounted
	return experience;
}
